import request from '@/axios/index';
// 报名
// export function sign_up(query) {
//     return request({
//         url: '/activity/recruit_applicant/sign_up',
//         method: 'post',
//         headers: {
//             port: '9760'
//         },
//         data: query
//     })
// }

// 噗丸社交APP文章管理 - 文章明细查询
export function getArticle(query) {
    return request({
        url: '/puwan_share/article/getArticle',
        method: 'get',
        headers: {
            port: '9350'
        },
        params: query
    })
}
// 评论列表
export function commentList(query) {
    return request({
        url: '/puwan_share/article_comment/lists',
        method: 'post',
        headers: {
            port: '9350'
        },
        data: query
    })
}

// 下载App
export function download(query) {
    return request({
        url: '/share/app/download',
        method: 'get',
        headers: {
            port: '9350'
        },
        params: query
    })
}
export function apiHelp(query) {
  return request({
      url: '/wallpaper/tAppWallpaper/problem_help',
      method: 'get',
      headers: {
          port: '9400'
      },
      params: query
  })
}
// 下载App
export function apiDownload(query) {
  return request({
      url: '/wallpaper/app/download',
      method: 'get',
      headers: {
          port: '9500'
      },
      params: query
  })
}

export function find_id(query) {
    return request({
        url: '/app_wallpaper/activity_configure/find_id',
        method: 'get',
        headers: {
            port: '9400'
        },
        params: query
    })
  }